module.exports = __webpack_public_path__ + "assets/img/driver-active-btn-c314b182.png";